export default {
  'career-expo': {
    id: 'career-expo',
    name: 'Career Expo',
    date: '10 & 11 March 2020',
    options: {
      'normal-stand': {
        id: 'normal-stand',
        name: 'Normal Stand (12 m<sup>2</sup>)',
        price: 1950,
        description: `
          <ul>
            <li>Stand of 4 by 3 meters</li>
            <li>2 standing tables</li>
            <li>3 barstools</li>
            <li>5 employees (incl. lunch)</li>
            <li>3 parking tickets</li>
            <li>Page in Company Guide</li>
            <li>Link on website</li>
          </ul>
        `,
        employees: 5,
        tables: 2,
        barstools: 3
      },
      'small-stand': {
        id: 'small-stand',
        name: 'Small Stand (6 m<sup>2</sup>)',
        price: 900,
        description: `
          <ul>
            <li>Stand of 3 by 2 meters</li>
            <li>1 standing tables</li>
            <li>2 barstools</li>
            <li>2 employees (incl. lunch)</li>
            <li>1 parking tickets</li>
            <li>Page in Company Guide</li>
            <li>Link on website</li>
          </ul>
        `,
        employees: 3,
        tables: 1,
        barstools: 2
      },
      'experience-center': {
        id: 'experience-center',
        name: 'Experience Center',
        price: 400,
        dataField: 'ExperienceCenter',
        summary: 'Participate in the Experience Center during the Career Expo',
        description: `
          <ul>
            <li>Extension of the normal stand (Object can be placed outside in consulation)</li>
            <li>4 employees (incl. lunch)</li>
            <li>2 parking tickets</li>
          </ul>
        `,
        popup: {
          button: 'Examples',
          content: `
            <div class="row">
              <div class="col-sm-6">
                <img src="./experience-center/Experience_center_1.jpg" />
              </div>
              <div class="col-sm-6">
                <img src="./experience-center/Experience_center_2.png" />
              </div>
              <div class="col-sm-6">
                <img src="./experience-center/Experience_center_3.jpg" />
              </div>
              <div class="col-sm-6">
                <img src="./experience-center/Experience_center_4.png" />
              </div>
            </div>
          `
        }
      },
      'speed-dates': {
        id: 'speed-dates',
        name: 'Speed Dates',
        price: 165,
        dataField: 'SpeedDates',
        summary: 'Participate in Speed Dates during the Career Expo',
        description: `
          <ul>
            <li>2 sessions of 35 minutes</li>
            <li>3 students per session</li>
            <li>1 employee (incl. lunch)</li>
          </ul>
        `
      },
      'extra-employee': {
        id: 'extra-employee',
        name: 'Extra Employee',
        price: 150,
        dataField: 'ExtraWorkers',
        summary: 'Number of extra workers for the Career Expo',
        description: `
          <ul>
            <li>incl. lunch &amp; parking ticket</li>
          </ul>
        `
      },
      'extra-table': {
        id: 'extra-table',
        name: 'Extra table',
        price: 0,
        dataField: 'ExtraTables',
        summary: 'Number of extra tables on the Career Expo',
        description: ``,
        hidden: true
      },
      'extra-barstool': {
        id: 'extra-barstool',
        name: 'Extra barstool',
        price: 0,
        dataField: 'ExtraStools',
        summary: 'Number of extra barstools on the Career Expo',
        description: ``,
        hidden: true
      }
    },
    popup: {
      button: 'Impression',
      content: `
        <div class="row">
          <div class="col-sm-6">
            <img src="./career-expo/career-expo-1.jpg" />
          </div>
          <div class="col-sm-6">
            <img src="./career-expo/career-expo-2.jpg" />
          </div>
          <div class="col-sm-6">
            <img src="./career-expo/career-expo-3.jpg" />
          </div>
          <div class="col-sm-6">
            <img src="./career-expo/career-expo-4.jpg" />
          </div>
          <div class="col-sm-6">
            <img src="./career-expo/career-expo-5.jpg" />
          </div>
          <div class="col-sm-6">
            <img src="./career-expo/career-expo-6.jpg" />
          </div>
          <div class="col-sm-6">
            <img src="./career-expo/career-expo-7.jpg" />
          </div>
          <div class="col-sm-6">
            <img src="./career-expo/career-expo-8.jpg" />
          </div>
          <div class="col-sm-6">
            <img src="./career-expo/career-expo-9.jpg" />
          </div>
        </div>
      `
    }
  },
  'interviewing-days': {
    id: 'interviewing-days',
    name: 'Interviewing Days',
    date: '20 - 24 April 2020',
    options: {
      'interview': {
        id: 'interview',
        name: 'Interview',
        price: 450,
        dataField: 'Interviews',
        summary: 'Amount of Interviews during the Interviewing Days',
        description: `
          <ul>
            <li>4 hours per session</li>
            <li>Maximum of 2 students per hour</li>
            <li>1 employee</li>
          </ul>
        `
      },
      'lunch': {
        id: 'lunch',
        name: 'Lunch',
        price: 550,
        dataField: 'Lunches',
        summary: 'Amount of Lunches during the Interviewing Days',
        description: `
          <ul>
            <li>2 hours</li>
            <li>8 students</li>
            <li>2 employees</li>
          </ul>
        `
      },
      'dinner-drink': {
        id: 'dinner-drink',
        name: 'Dinner & Drink',
        price: 600,
        dataField: 'Diners',
        summary: 'Amount of Dinners &amp; Drinks during the Interviewing Days',
        description: `
          <ul>
            <li>Circa 4 hours</li>
            <li>8 students</li>
            <li>2 employees</li>
          </ul>
        `
      },
      'company-case': {
        id: 'company-case',
        name: 'Company Case',
        price: 550,
        dataField: 'Cases',
        summary: 'Amount of Company Cases during the Interviewing Days',
        description: `
          <ul>
            <li>3 hours</li>
            <li>30 students</li>
            <li>3 employees</li>
          </ul>
        `
      }
    },
    popup: {
      button: 'Impression',
      content: `
        <div class="row">
          <div class="col-sm-6">
            <img src="./interviewing-days/interviewing-days-1.jpg" />
          </div>
          <div class="col-sm-6">
            <img src="./interviewing-days/interviewing-days-2.jpg" />
          </div>
          <div class="col-sm-6">
            <img src="./interviewing-days/interviewing-days-3.jpg" />
          </div>
          <div class="col-sm-6">
            <img src="./interviewing-days/interviewing-days-4.jpg" />
          </div>
          <div class="col-sm-6">
            <img src="./interviewing-days/interviewing-days-5.jpg" />
          </div>
          <div class="col-sm-6">
            <img src="./interviewing-days/interviewing-days-6.jpg" />
          </div>
          <div class="col-sm-6">
            <img src="./interviewing-days/interviewing-days-7.jpg" />
          </div>
        </div>
      `
    }
  }
};